import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Output() change = new EventEmitter();
  menuList:any;
  selectedItem:any;
  UserName:any;
  RoleName: string;
  constructor(private router: Router) { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    let selectedMenuId=localStorage.getItem('selectedMenu');
    if(selectedMenuId !=null && selectedMenuId != '' && typeof(selectedMenuId)!=undefined)
      this.selectedItem=selectedMenuId;
    else{
      if(this.menuList.length!=0)
        this.selectedItem=this.menuList[0].KM_MenuId;
    }  
  }

  listClick(event, newValue) {
    localStorage.setItem('selectedMenu',newValue);
    this.selectedItem = newValue;  
}
Logout(){
  localStorage.clear();
  localStorage.removeItem('userName');
  this.UserName="";
  this.router.navigate(['/login']);
}

}



// WEBPACK FOOTER //
// ./src/app/common/header/header.component.ts